/* LPS — ampul (galeri ışığı) + render'ı olan ürün kartlarında görsel değişimi.
   window.LPS = { handle: { card_on, card_off, ... } } sections/lps-global içinde basılır. */
(function () {
  var root = document.documentElement, KEY = 'lps-light';
  var BULB = '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="glass" d="M9 17h6v-1.2c0-1 .5-1.8 1.3-2.6A6 6 0 1 0 7.7 13.2c.8.8 1.3 1.6 1.3 2.6z"/><path d="M9.5 20h5M10.5 22h3M12 13v-3m-1.5 1.5L12 10l1.5 1.5"/></svg>';

  function sync() {
    document.querySelectorAll('.lps-lamp').forEach(function (b) { b.setAttribute('aria-pressed', root.dataset.light === 'on'); });
  }
  function toggle() {
    root.dataset.light = root.dataset.light === 'on' ? 'off' : 'on';
    try { localStorage.setItem(KEY, root.dataset.light); } catch (e) {}
    sync();
  }

  function lamp() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.lps-lamp')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'lps-lamp'; b.setAttribute('aria-label', 'Gallery lights');
    b.innerHTML = BULB + '<span class="st"></span>';
    b.addEventListener('click', toggle);
    icons.insertBefore(b, icons.firstChild);
    sync();
  }

  // Render'ı olan ürünlerin kartlarında Etsy kapağı yerine ışıklı/ışıksız render çifti
  function cards() {
    var map = window.LPS || {}, n = 0;
    document.querySelectorAll('.card-wrapper').forEach(function (c) {
      if (c.dataset.lps) return;
      var a = c.querySelector('a[href*="/products/"]');
      if (!a) return;
      var handle = a.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0];
      var r = map[handle], media = c.querySelector('.card__media .media');
      if (!r || !media) return;
      c.dataset.lps = '1';
      media.innerHTML = '<img class="lps-off" src="' + r.card_off + '&width=720" alt="" loading="lazy">' +
        '<img class="lit-on" style="--d:' + Math.min(n++ * 0.07, 0.6) + 's" src="' + r.card_on + '&width=720" alt="" loading="lazy">';
      c.querySelectorAll('.card, .card__inner').forEach(function (el) { el.style.setProperty('--ratio-percent', '125%'); });
    });
  }

  // Ürün sayfası galerisi: küçük görsele tıklayınca büyük görsel (iki ışık katmanıyla) değişir
  function gallery() {
    var off = document.getElementById('lpsMainOff'), on = document.getElementById('lpsMainOn'), stage = document.querySelector('.lps-stage');
    if (!off) return;
    document.querySelectorAll('.lps-thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        // 3B küçük resmi görüntüleyiciyi açar, ötekiler görsele döner
        if (stage) stage.classList.toggle('is-3d', b.dataset.view === '3d');
        if (b.dataset.view !== '3d') { off.src = b.dataset.off; if (on) on.src = b.dataset.on || b.dataset.off; }
        document.querySelectorAll('.lps-thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === b); });
      });
    });
  }

  function init() { lamp(); cards(); gallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Dawn bazı ızgaraları sonradan yüklüyor (filtre, ilgili ürünler)
  new MutationObserver(function () { cards(); lamp(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
